"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleQuestionUpdated = exports.handleLeaderboardUpdated = exports.refreshMyBet = exports.getMyBet = exports.getBetbar = exports.setBetbar = exports.SET_BETBAR = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _reactUtils = require("@low6dev/react-utils");

var _reactToastify = require("react-toastify");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var SET_BETBAR = "betbar:SET_BETBAR";
exports.SET_BETBAR = SET_BETBAR;

var setBetbar = function setBetbar(payload, setBetbarParent) {
  return function (dispatch) {
    dispatch({
      type: SET_BETBAR,
      payload: payload
    });
    setTimeout(function () {
      if (setBetbarParent) {
        console.log("SETTING BETBAR PARENT!!!", payload);
        setBetbarParent(payload);
      }
    }, 500);
  };
};

exports.setBetbar = setBetbar;

var buildPickemList = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(pickemList) {
    var newPickemList, _iterator, _step, _pickemRes$data, _pickemData$data, _sportMatchRes, _sportMatchRes$data, _pickem$bets, _pickem$bets2, pickem, pickemRes, pickemData, sportMatchRes, sportMatch, _pickemData$data$spor, _pickemData$data2, _pickemData$data2$spo, _pickemData$data3, _pickemData$footballM, newPickem, _iterator2, _step2, _pickemData$activeBet, bet, extraPickem;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            newPickemList = [];
            _iterator = _createForOfIteratorHelper(pickemList);
            _context.prev = 2;

            _iterator.s();

          case 4:
            if ((_step = _iterator.n()).done) {
              _context.next = 30;
              break;
            }

            pickem = _step.value;
            _context.next = 8;
            return _axios.default.get("/pickems/".concat(pickem === null || pickem === void 0 ? void 0 : pickem.id));

          case 8:
            pickemRes = _context.sent;
            pickemData = pickemRes === null || pickemRes === void 0 ? void 0 : (_pickemRes$data = pickemRes.data) === null || _pickemRes$data === void 0 ? void 0 : _pickemRes$data.data;
            sportMatchRes = void 0;
            sportMatch = void 0;

            if (!(pickemData !== null && pickemData !== void 0 && (_pickemData$data = pickemData.data) !== null && _pickemData$data !== void 0 && _pickemData$data.id)) {
              _context.next = 18;
              break;
            }

            _context.next = 15;
            return _axios.default.get("sport-match/".concat((_pickemData$data$spor = pickemData === null || pickemData === void 0 ? void 0 : (_pickemData$data2 = pickemData.data) === null || _pickemData$data2 === void 0 ? void 0 : (_pickemData$data2$spo = _pickemData$data2.sport) === null || _pickemData$data2$spo === void 0 ? void 0 : _pickemData$data2$spo.slug) !== null && _pickemData$data$spor !== void 0 ? _pickemData$data$spor : "custom-sport", "/").concat(pickemData === null || pickemData === void 0 ? void 0 : (_pickemData$data3 = pickemData.data) === null || _pickemData$data3 === void 0 ? void 0 : _pickemData$data3.id));

          case 15:
            sportMatchRes = _context.sent;
            _context.next = 21;
            break;

          case 18:
            _context.next = 20;
            return _axios.default.get("football/matches/".concat(pickemData === null || pickemData === void 0 ? void 0 : (_pickemData$footballM = pickemData.footballMatch) === null || _pickemData$footballM === void 0 ? void 0 : _pickemData$footballM.id));

          case 20:
            sportMatchRes = _context.sent;

          case 21:
            sportMatch = (_sportMatchRes = sportMatchRes) === null || _sportMatchRes === void 0 ? void 0 : (_sportMatchRes$data = _sportMatchRes.data) === null || _sportMatchRes$data === void 0 ? void 0 : _sportMatchRes$data.data;
            pickemData.sportMatch = sportMatch;
            pickemData.usersBets = pickem === null || pickem === void 0 ? void 0 : pickem.bets;
            pickemData.activeBet = (pickem === null || pickem === void 0 ? void 0 : (_pickem$bets = pickem.bets) === null || _pickem$bets === void 0 ? void 0 : _pickem$bets.length) > 0 && (pickem === null || pickem === void 0 ? void 0 : pickem.bets[0]);
            newPickem = _objectSpread(_objectSpread({}, pickemData), {}, {
              sportMatch: sportMatch
            });
            newPickemList.push(newPickem);

            if ((pickem === null || pickem === void 0 ? void 0 : (_pickem$bets2 = pickem.bets) === null || _pickem$bets2 === void 0 ? void 0 : _pickem$bets2.length) > 1) {
              _iterator2 = _createForOfIteratorHelper(pickem === null || pickem === void 0 ? void 0 : pickem.bets);

              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  bet = _step2.value;

                  if ((bet === null || bet === void 0 ? void 0 : bet.betId) !== (pickemData === null || pickemData === void 0 ? void 0 : (_pickemData$activeBet = pickemData.activeBet) === null || _pickemData$activeBet === void 0 ? void 0 : _pickemData$activeBet.betId)) {
                    extraPickem = _objectSpread(_objectSpread({}, newPickem), {}, {
                      activeBet: bet
                    });
                    newPickemList.push(extraPickem);
                  }
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            }

          case 28:
            _context.next = 4;
            break;

          case 30:
            _context.next = 35;
            break;

          case 32:
            _context.prev = 32;
            _context.t0 = _context["catch"](2);

            _iterator.e(_context.t0);

          case 35:
            _context.prev = 35;

            _iterator.f();

            return _context.finish(35);

          case 38:
            return _context.abrupt("return", newPickemList.reverse());

          case 39:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 32, 35, 38]]);
  }));

  return function buildPickemList(_x) {
    return _ref.apply(this, arguments);
  };
}();

var getBetbar = function getBetbar(setBetbarParent) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var _activePickemListRes$, _populatedActivePicke, populatedActivePickemList, activePickemListRes, activePickemList, latestPickem, filteredPickems, isContestEmpty, activePickem, activeBet, hasPickemsAllowingMultipleBets, payload, response;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              populatedActivePickemList = []; // const activePickemListRes = await axios.get(
              //   "/pickems-dates?include_status=Approved,In_play,Completed"
              // );

              _context2.next = 4;
              return _axios.default.get("/pickems-most-recent?sub_days=".concat(process.env.REACT_APP_PICKEM_DAYS_TO_DISPLAY || 7, "&include_status=Approved,Completed,In_play"));

            case 4:
              activePickemListRes = _context2.sent;
              activePickemList = (_activePickemListRes$ = activePickemListRes.data) === null || _activePickemListRes$ === void 0 ? void 0 : _activePickemListRes$.data;
              latestPickem = activePickemList[0]; // const filteredPickems = activePickemList?.filter(
              //   (obj) => obj.start.substr(0, 10) === latestPickem?.start.substr(0, 10)
              // );

              filteredPickems = activePickemList;
              isContestEmpty = false;

              if (!(activePickemList !== null && activePickemList !== void 0 && activePickemList.length)) {
                _context2.next = 15;
                break;
              }

              _context2.next = 12;
              return buildPickemList(filteredPickems);

            case 12:
              populatedActivePickemList = _context2.sent;
              _context2.next = 17;
              break;

            case 15:
              isContestEmpty = true;
              console.log("no pickems to display", filteredPickems);

            case 17:
              activePickem = populatedActivePickemList[0];
              activeBet = (_populatedActivePicke = populatedActivePickemList[0]) === null || _populatedActivePicke === void 0 ? void 0 : _populatedActivePicke.activeBet;
              hasPickemsAllowingMultipleBets = populatedActivePickemList.some(function (obj) {
                return obj.maxBetsPerUser;
              });
              payload = {
                isContestEmpty: isContestEmpty,
                hadBet: activeBet ? true : false,
                activeBet: activeBet,
                activePickem: activePickem,
                isBetsOpen: false,
                isBetbarLoading: false,
                isActivePickemInPlay: (activePickem === null || activePickem === void 0 ? void 0 : activePickem.status) === "IN_PLAY",
                isActivePickemCompleted: (activePickem === null || activePickem === void 0 ? void 0 : activePickem.status) === "COMPLETED",
                isActivePickemApproved: (activePickem === null || activePickem === void 0 ? void 0 : activePickem.status) === "APPROVED",
                activePickemList: populatedActivePickemList
              };
              console.log("were not getting here ");
              dispatch(setBetbar(payload, setBetbarParent));
              _context2.next = 29;
              break;

            case 25:
              _context2.prev = 25;
              _context2.t0 = _context2["catch"](0);
              response = _context2.t0.response;
              (0, _reactUtils.handleError)(response);

            case 29:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 25]]);
    }));

    return function (_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};

exports.getBetbar = getBetbar;

var getMyBet = function getMyBet(setLeaderboard, activeUserBet, isShowingMyBet) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState) {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              dispatch(setLeaderboard({
                activeUserBet: isShowingMyBet ? activeUserBet : undefined,
                isShowingMyBet: isShowingMyBet
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x4, _x5) {
      return _ref4.apply(this, arguments);
    };
  }();
};

exports.getMyBet = getMyBet;

var refreshMyBet = function refreshMyBet(activeBetId, setBetbarParent) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch) {
      var activeBetSelectionsResponse, activeBet, response;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return _axios.default.get("/pickem-cached-bet/".concat(activeBetId));

            case 3:
              activeBetSelectionsResponse = _context4.sent;
              activeBet = activeBetSelectionsResponse === null || activeBetSelectionsResponse === void 0 ? void 0 : activeBetSelectionsResponse.data;
              console.log("ITS THIS DUDE!!!!");
              dispatch(setBetbar({
                activeBet: activeBet
              }, setBetbarParent));
              _context4.next = 13;
              break;

            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4["catch"](0);
              response = _context4.t0.response;
              (0, _reactUtils.handleError)(response);

            case 13:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 9]]);
    }));

    return function (_x6) {
      return _ref5.apply(this, arguments);
    };
  }();
};

exports.refreshMyBet = refreshMyBet;

var handleLeaderboardUpdated = function handleLeaderboardUpdated(data, activeBetId, setBetbarParent) {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(dispatch, getState) {
      var _data$leaderboard, _data$leaderboard$dat, _getState$betbar, _getState$betbar$tabl, _getState$betbar2, _getState$betbar2$act;

      var pusherLeaderboardBets, leaderboardBets, activeBetSelectionsResponse, activeBet;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              pusherLeaderboardBets = data === null || data === void 0 ? void 0 : (_data$leaderboard = data.leaderboard) === null || _data$leaderboard === void 0 ? void 0 : (_data$leaderboard$dat = _data$leaderboard.data) === null || _data$leaderboard$dat === void 0 ? void 0 : _data$leaderboard$dat.map(function (obj) {
                return obj.betId;
              });
              leaderboardBets = (_getState$betbar = getState().betbar) === null || _getState$betbar === void 0 ? void 0 : (_getState$betbar$tabl = _getState$betbar.table) === null || _getState$betbar$tabl === void 0 ? void 0 : _getState$betbar$tabl.map(function (obj) {
                return obj.betId;
              }).slice(25); // check for leaderboard updates

              if (!(JSON.stringify(leaderboardBets) !== JSON.stringify(pusherLeaderboardBets) && ((_getState$betbar2 = getState().betbar) === null || _getState$betbar2 === void 0 ? void 0 : (_getState$betbar2$act = _getState$betbar2.activePickem) === null || _getState$betbar2$act === void 0 ? void 0 : _getState$betbar2$act.status) === "IN_PLAY")) {
                _context5.next = 11;
                break;
              }

              console.log("leaderboard has changed", data); // const betRefreshed = await dispatch(
              //   refreshMyBet(activeBetId, setBetbarParent)
              // );
              // refresh my bet

              _context5.next = 6;
              return _axios.default.get("/pickem-cached-bet/".concat(activeBetId));

            case 6:
              activeBetSelectionsResponse = _context5.sent;
              activeBet = activeBetSelectionsResponse === null || activeBetSelectionsResponse === void 0 ? void 0 : activeBetSelectionsResponse.data;
              dispatch(setBetbar({
                activeBet: activeBet,
                table: data.leaderboard.data
              }, setBetbarParent)); // dispatch({
              //   type: SET_LEADERBOARD,
              //   payload: { table: data.leaderboard.data },
              // });

              _context5.next = 12;
              break;

            case 11:
              console.log("leaderboard DID NOT change");

            case 12:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x7, _x8) {
      return _ref7.apply(this, arguments);
    };
  }();
};

exports.handleLeaderboardUpdated = handleLeaderboardUpdated;

var handleQuestionUpdated = function handleQuestionUpdated(pusherPickem, setBetbarParent) {
  return /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(dispatch, getState) {
      var _getState$betbar3;

      var question, pusherMatchInfo, hasMatchUpdates, hasGoalScored, hasGoalDisallowed, activePickem, activePickemQuestion, _getState$betbar4, _getState$betbar4$act, activePickemList, activePickemsWithSameMatch, _iterator3, _step3, p, activeBet, _getState$betbar5, _getState$betbar5$act, activeBetSelectionsResponse;

      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              console.log("handlePusherEvent", pusherPickem);
              question = pusherPickem.question;
              pusherMatchInfo = question.data;
              activePickem = (_getState$betbar3 = getState().betbar) === null || _getState$betbar3 === void 0 ? void 0 : _getState$betbar3.activePickem; // update questions and options

              activePickemQuestion = activePickem === null || activePickem === void 0 ? void 0 : activePickem.questions.find(function (obj) {
                return obj.id === (question === null || question === void 0 ? void 0 : question.id);
              });
              activePickemQuestion === null || activePickemQuestion === void 0 ? void 0 : activePickemQuestion.options.forEach(function (item, i) {
                item.points = question.options[i].points;
              });

              if ((activePickem === null || activePickem === void 0 ? void 0 : activePickem.status) !== (pusherPickem === null || pusherPickem === void 0 ? void 0 : pusherPickem.status)) {
                activePickem.status = pusherPickem === null || pusherPickem === void 0 ? void 0 : pusherPickem.status;
                hasMatchUpdates = true;
              }

              if (activePickem.footballMatch.matchTime !== pusherMatchInfo.matchTime) {
                activePickem.footballMatch.matchTime = pusherMatchInfo.matchTime;
                hasMatchUpdates = true;
              }

              if (activePickem.footballMatch.period !== pusherMatchInfo.period) {
                activePickem.footballMatch.period = pusherMatchInfo.period;
                hasMatchUpdates = true;
              } // check only for goal scored


              if (pusherMatchInfo.homeScore > activePickem.footballMatch.homeScore || pusherMatchInfo.awayScore > activePickem.footballMatch.awayScore) {
                hasGoalScored = true;
                console.log("GOAL SCORED!!", hasGoalScored);
              }

              if (pusherMatchInfo.homeScore < activePickem.footballMatch.homeScore || pusherMatchInfo.awayScore < activePickem.footballMatch.awayScore) {
                hasGoalDisallowed = true;
                console.log("VAR DISALLOWED!!", hasGoalDisallowed);
              }

              if (activePickem.footballMatch.homeScore !== pusherMatchInfo.homeScore) {
                activePickem.footballMatch.homeScore = pusherMatchInfo.homeScore;
                hasMatchUpdates = true;
              }

              if (activePickem.footballMatch.awayScore !== pusherMatchInfo.awayScore) {
                activePickem.footballMatch.awayScore = pusherMatchInfo.awayScore;
                hasMatchUpdates = true;
              } // const question = activePickem.questions.find(
              //   (obj) => obj.id === pusherPickem.question.id
              // );


              if (!hasMatchUpdates) {
                _context6.next = 26;
                break;
              }

              console.log("There have been match updates!", pusherPickem);
              activePickemList = getState().betbar.activePickemList; // check for other pickems with same match

              activePickemsWithSameMatch = activePickemList === null || activePickemList === void 0 ? void 0 : activePickemList.filter(function (obj) {
                var _obj$footballMatch, _activePickem$footbal;

                return (obj === null || obj === void 0 ? void 0 : (_obj$footballMatch = obj.footballMatch) === null || _obj$footballMatch === void 0 ? void 0 : _obj$footballMatch.id) === (activePickem === null || activePickem === void 0 ? void 0 : (_activePickem$footbal = activePickem.footballMatch) === null || _activePickem$footbal === void 0 ? void 0 : _activePickem$footbal.id);
              });

              if (activePickemsWithSameMatch !== null && activePickemsWithSameMatch !== void 0 && activePickemsWithSameMatch.length) {
                _iterator3 = _createForOfIteratorHelper(activePickemsWithSameMatch);

                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    p = _step3.value;
                    p.footballMatch.homeScore = activePickem.footballMatch.homeScore;
                    p.footballMatch.awayScore = activePickem.footballMatch.awayScore;
                    p.footballMatch.matchTime = activePickem.footballMatch.matchTime;
                    p.footballMatch.period = activePickem.footballMatch.period;
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }
              }

              if (!((_getState$betbar4 = getState().betbar) !== null && _getState$betbar4 !== void 0 && (_getState$betbar4$act = _getState$betbar4.activeBet) !== null && _getState$betbar4$act !== void 0 && _getState$betbar4$act.betId)) {
                _context6.next = 23;
                break;
              }

              _context6.next = 21;
              return _axios.default.get("/pickem-cached-bet/".concat((_getState$betbar5 = getState().betbar) === null || _getState$betbar5 === void 0 ? void 0 : (_getState$betbar5$act = _getState$betbar5.activeBet) === null || _getState$betbar5$act === void 0 ? void 0 : _getState$betbar5$act.betId));

            case 21:
              activeBetSelectionsResponse = _context6.sent;
              activeBet = activeBetSelectionsResponse === null || activeBetSelectionsResponse === void 0 ? void 0 : activeBetSelectionsResponse.data; // dispatch(
              //   refreshMyBet(getState().betbar?.activeBet?.betId, setBetbarParent)
              // );

            case 23:
              dispatch(setBetbar({
                hasGoalScored: hasGoalScored,
                hasGoalDisallowed: hasGoalDisallowed,
                activePickem: activePickem,
                activeBet: activeBet,
                isActivePickemInPlay: (activePickem === null || activePickem === void 0 ? void 0 : activePickem.status) === "IN_PLAY",
                isActivePickemApproved: (activePickem === null || activePickem === void 0 ? void 0 : activePickem.status) === "APPROVED",
                isActivePickemCompleted: (activePickem === null || activePickem === void 0 ? void 0 : activePickem.status) === "COMPLETED"
              }, setBetbarParent));
              _context6.next = 27;
              break;

            case 26:
              console.log("NO MATCH UPDATES", pusherPickem);

            case 27:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x9, _x10) {
      return _ref8.apply(this, arguments);
    };
  }();
};

exports.handleQuestionUpdated = handleQuestionUpdated;